import React, { Component } from 'react';
import HotTable from 'react-handsontable';

class HotComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {};
    this.hotDatazz = JSON.parse(JSON.stringify(props.hotData));
  }
  // tableChange = (changes, source) => {
  //   this.props.tableChange(this.handsontableData, changes, source);
  // }

  componentDidMount() {

  }
  shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(nextProps) !== JSON.stringify(this.props)) {
      this.hotDatazz = JSON.parse(JSON.stringify(nextProps.hotData));
      return true;
    }
    return  false;
  }
  render() {
    // this.hotDatazz = JSON.parse(JSON.stringify(this.props.hotData));
    return (
      <div ref='tableWrapper'>
        <HotTable
          settings={{
            root: "hot",
            manualTableResize: true,
            data: this.hotDatazz,
            minCols: 26,
            minRows: 100,
            rowHeaderWidth: 25,
            colHeaders: true,
            fixedColHeaders: true,
            rowHeaders: true,
            contextMenu: true,
            manualColumnResize: true,
            manualRowResize: true,
            onAfterChange: (changes, source) => {this.props.hotChange(this.hotDatazz, changes, source)}
          }}/>
      </div>
    );
  }
}

export default HotComponent;



// WEBPACK FOOTER //
// ./src/_HotEditableComponent.js